module.exports = __webpack_public_path__ + "387c734f48cc3d15ae95dbc686b3deeb.mp4";